import { render, staticRenderFns } from "./PageAuth.vue?vue&type=template&id=ec0540f6&"
var script = {}
import style0 from "./PageAuth.vue?vue&type=style&index=0&id=ec0540f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports